import React from 'react';
import { UseQueryResult } from 'react-query';
import { match } from 'ts-pattern';
import TableLoading from '../../../components/Layout/Loading/TableLoading';
import { StrapiResponseList } from '../../../interfaces/commons';
import {
  SURVEY_ANSWER_LABELS,
  SurveyAnswer,
  SurveyAnswerResponse,
} from '../../../interfaces/surveyAnswers';

interface SurveyAnswersTableProps {
  query: UseQueryResult<StrapiResponseList<SurveyAnswerResponse>>;
}

const SurveyAnswersTable: React.FC<SurveyAnswersTableProps> = ({ query }) => {
  const tableElements = ['Cognome', 'Nome', 'Sezione', 'Nome corso', 'Risposta'];

  return (
    <div className='-my-2 overflow-x-auto'>
      <div className='inline-block min-w-full py-2 align-middle'>
        <div className='overflow-hidden ring-1 border ring-black ring-opacity-5 '>
          {match(query)
            .with({ status: 'idle' }, { status: 'loading' }, () => (
              <TableLoading tableElements={tableElements} />
            ))
            .with({ status: 'error' }, () => <div>Errore...</div>)
            .with({ status: 'success' }, (query) => {
              if (query.data) {
                return (
                  <table className='min-w-full divide-y divide-gray-300'>
                    <thead className='bg-gray-50 text-sm uppercase text-gray-500'>
                      <tr>
                        {tableElements.map((element, idx) => (
                          <th
                            key={idx}
                            className='font-normal px-6 py-3 text-left tracking-wide'
                          >
                            {element}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className='divide-y divide-gray-200 bg-white'>
                      {query.data.data.map((surveyAnswer) => {
                        const { attributes } = surveyAnswer;
                        const profile = attributes.profile?.data?.attributes;
                        const course = attributes.course?.data?.attributes;
                        const section = course?.section?.data?.attributes.name;
                        const courseTitle = course?.title;
                        const answerLabel =
                          attributes.answer === SurveyAnswer.ALTRO
                            ? `Altro: ${attributes.answerOther || '-'}`
                            : SURVEY_ANSWER_LABELS[attributes.answer];

                        return (
                          <tr key={surveyAnswer.id}>
                            <td className='whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-600'>
                              {profile?.surname || '-'}
                            </td>
                            <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-500'>
                              {profile?.name || '-'}
                            </td>
                            <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-500'>
                              {section || '-'}
                            </td>
                            <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-500'>
                              {courseTitle || '-'}
                            </td>
                            <td className='whitespace-nowrap px-6 py-4 text-sm text-gray-500'>
                              {answerLabel}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                );
              } else {
                return (
                  <div className='text-gray-500 my-20 text-center'>
                    Non hai i permessi
                  </div>
                );
              }
            })
            .exhaustive()}
        </div>
      </div>
    </div>
  );
};

export default SurveyAnswersTable;
